//暴露常量
export const TEST_INCREMENT='TEST_INCREMENT'
export const TEST_DEREMENT='TEST_DEREMENT'

export const USER_INFO = 'USER_INFO'; // 保存用户信息
export const INIT_USER_INFO = 'INIT_USER_INFO'; // 初始化用户数据
export const RESET_USER_INFO = 'RESET_USER_INFO'; // 重置用户数据



// WEBPACK FOOTER //
// ./src/vuex/types.js